import { fromJS } from 'immutable'
import {
  REPORT_HEADCOUNT_GET_REQUEST,
  REPORT_HEADCOUNT_GET_SUCCESS,
  REPORT_HEADCOUNT_GET_FAILURE,
  REPORT_HEADCOUNT_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case REPORT_HEADCOUNT_GET_REQUEST:
      return state
        .set('isFetching', true)
    case REPORT_HEADCOUNT_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('headCount', fromJS(action.payload.headCountData))
        .set('status', 200)
    case REPORT_HEADCOUNT_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('headCount', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case REPORT_HEADCOUNT_GET_RESET:
      return state
        .delete('headCount')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report/report-headcount-get-reducer.js